module.exports = __webpack_public_path__ + "img/jbipaces_thumbnail_img@2x.b23ddb47.png";